import React from 'react';
import { isNotEmpty } from '../utils/Validator.js';

import '../App.css';

function GlobalMessage(props) {
    const { type, message, style } = props;
    let styleClass = "globalSuccessMessage";

    if (type === "error") {
        styleClass = "globalErrorMessage"
    }

    if (isNotEmpty(message)) {
        if (message.includes('mailto:')) {
            return (
                <div 
                    className={styleClass} 
                    style={style} 
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            );
        } else {
            // Regular rendering for messages without links
            return (<div className={styleClass} style={style}>{message}</div>);
        }
    } else {
        return (null);
    }
}

GlobalMessage.defaultProps = {
    type: 'error'
};

export default GlobalMessage;
